export default __webpack_public_path__ + "static/media/category3.d3404151.png";